<div
        *ngFor="let file of widgetData?.content?.data"
        class="division-item"
>
    <div
            class="division-item item-head flex-display align-items-center justify-content-between"
    >
        <div class="flex-display align-items-center">
            <i
                    class="icon-file me-1"
                    ngbTooltip="{{ 'USER_PROFILE.TEXT.DOC.FILE' | translate }}"
            ></i>
            <span
                    (click)="navigateTo('account/doc/nav/file/' + file.key)"
                    class="text-primary pointer"
            >
				{{ file.name }} <br/>
				<small class="text-info">{{
                        file.updated_at | date : 'HH:mm dd.MM.yyyy'
                    }}</small>
			</span>
        </div>
    </div>
</div>
<app-component-pagination
        *ngIf="widgetData.content?.page_count > 1"
        [pagination]="{
		pages: widgetData.content.page_count,
		current_page: widgetData.content.current_page,
		limit: 20
	}"
        [totalPages]="widgetData.content.page_count"
        [totalPages]="widgetData.content.page_count"
></app-component-pagination>
